import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=a43975b0&scoped=true"
import script from "./CardTitle.vue?vue&type=script&lang=js"
export * from "./CardTitle.vue?vue&type=script&lang=js"
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=a43975b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43975b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/dev-official-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a43975b0')) {
      api.createRecord('a43975b0', component.options)
    } else {
      api.reload('a43975b0', component.options)
    }
    module.hot.accept("./CardTitle.vue?vue&type=template&id=a43975b0&scoped=true", function () {
      api.rerender('a43975b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardTitle.vue"
export default component.exports